import { createAsyncThunk } from '@reduxjs/toolkit';
import { getProfile, loginUser, logoutUser, updateProfile } from '../api/authApi';
import { showAlert } from '../slices/alertsSlice';
import { clearToken, setProfile, setToken } from '../slices/authSlice';
import { handleError } from '../slices/errorsSlice';
import { startLoading, endLoading } from '../slices/loadingSlice';

export const login = createAsyncThunk('auth/login', ({ email, password, callback }, { dispatch }) => {
  dispatch(startLoading());

  loginUser(email, password)
  .then(response => response.status === 200 ? response.json() : Promise.reject(response))
  .then(data => {
    dispatch(setToken({ token: data.token }));
  })
  .then(() => callback())
  .catch(err => dispatch(handleError(err)))
  .finally(() => dispatch(endLoading()));
});

export const logout = createAsyncThunk('auth/logout', ({ callback }, { getState, dispatch }) => {
  const { token } = getState().auth;

  dispatch(startLoading());

  logoutUser(token)
  .then(response => response.status === 200 ? response.json() : Promise.reject(response))
  .then(() => {
    dispatch(clearToken());
  })
  .then(() => callback())
  .catch(err => dispatch(handleError(err)))
  .finally(() => dispatch(endLoading()));
});

export const getMyProfile = createAsyncThunk('auth/getMyProfile', (_, { getState, dispatch }) => {
  const { token } = getState().auth;

  dispatch(startLoading());

  getProfile(token)
  .then(response => response.status === 200 ? response.json() : Promise.reject(response))
  .then(data => dispatch(setProfile({ profile: data.user })))
  .catch(err => dispatch(handleError(err)))
  .finally(() => dispatch(endLoading()));
});

export const updateMyProfile = createAsyncThunk('users/updateMyProfile', ({ user }, { getState, dispatch }) => {
  const { token } = getState().auth;

  dispatch(startLoading());
  
  updateProfile(token, user)
  .then(response => response.status === 200 ? response.json() : Promise.reject(response))
  .then(data => dispatch(setProfile({ profile: data.user })))
  .then(() => dispatch(showAlert({ message: 'Perfil actualizado', type: 'success' })))
  .catch(err => dispatch(handleError(err)))
  .finally(() => dispatch(endLoading()));
});
